var map = {
	"./2D.svg": "465bb",
	"./3D.svg": "fdd6",
	"./add-plus.svg": "a5dc",
	"./alert.svg": "ddeb7",
	"./arrow-back.svg": "c00d",
	"./arrows-maximize.svg": "5562",
	"./attribute-class.svg": "f437",
	"./bar-x.svg": "c2f5",
	"./bar.svg": "4ea3",
	"./basic.svg": "1586",
	"./boolean.svg": "b1bb",
	"./broken-clouds.svg": "57ed",
	"./bulldozer-1.svg": "ae4a",
	"./bulldozer-2.svg": "3d09",
	"./bus.svg": "5f3a",
	"./camera.svg": "f0b5",
	"./car-accident.svg": "3990e",
	"./car.svg": "d1c2",
	"./chart-line.svg": "240c",
	"./check.svg": "103a",
	"./chelyabinsk.svg": "7b42",
	"./chevron-down.svg": "fce4",
	"./chevron-left.svg": "3deb",
	"./chevron-right.svg": "db60",
	"./chevron-up.svg": "7b58",
	"./clear-input.svg": "c622",
	"./clear-sky-d.svg": "a379",
	"./clear-sky-n.svg": "03d6",
	"./close-delete.svg": "54ec",
	"./closed.svg": "7299",
	"./clouds-few-d.svg": "7c5e",
	"./clouds-few-n.svg": "685c",
	"./clouds.svg": "042d",
	"./columns.svg": "37bc",
	"./compass-north.svg": "de40",
	"./copy.svg": "f5377",
	"./database.svg": "284a",
	"./date-calendar.svg": "7c78",
	"./doughnut.svg": "b7ef",
	"./download.svg": "0791",
	"./drop-down.svg": "3dca",
	"./drop-right.svg": "95e7",
	"./drop-up.svg": "248f",
	"./edit-zone.svg": "eb2c",
	"./edit.svg": "9923",
	"./epure.svg": "29b4",
	"./file.svg": "782b",
	"./filter.svg": "91de",
	"./focus-zone.svg": "08ef",
	"./heatmap.svg": "f44b",
	"./help.svg": "cb5f",
	"./image.svg": "78f2",
	"./in-process.svg": "f010",
	"./ksodd-graphs.svg": "9ed8",
	"./ksodd-map.svg": "a7dd",
	"./ksodd-tables.svg": "eb46",
	"./ksodd.svg": "4b7a",
	"./layers-folder.svg": "ed11",
	"./legend.svg": "7c45",
	"./line.svg": "33d9",
	"./link-to.svg": "8430",
	"./list.svg": "b2ab",
	"./lock.svg": "c754",
	"./matrix.svg": "72c2",
	"./meteostation.svg": "db7c",
	"./mist.svg": "f725",
	"./mobile-menu.svg": "65a6",
	"./model.svg": "8e1c",
	"./modelling-calculate.svg": "4475",
	"./modelling-intense.svg": "3180",
	"./modelling-transport.svg": "6f92",
	"./modelling.svg": "5399",
	"./mtaxi.svg": "9bc33",
	"./node.svg": "b3de",
	"./notification.svg": "509c",
	"./number.svg": "84ed",
	"./other-actions.svg": "7fe1",
	"./outside-link.svg": "d162",
	"./pause.svg": "c6013",
	"./pie-rose.svg": "c0e4",
	"./pie.svg": "9510",
	"./play.svg": "b70c",
	"./podd.svg": "72bb",
	"./point.svg": "849a",
	"./polar.svg": "d146",
	"./polygon.svg": "e765",
	"./proposal.svg": "c351",
	"./rain-d.svg": "1ed6",
	"./rain-drop.svg": "c43a",
	"./rain-n.svg": "fa148",
	"./rain-shower.svg": "237f5",
	"./redo.svg": "ea27",
	"./replay.svg": "67b6",
	"./road-accident.svg": "33a5",
	"./road-event.svg": "11f4",
	"./road-work.svg": "69fa",
	"./s-center-editor.svg": "bca0",
	"./s-center.svg": "c86f",
	"./scatter.svg": "9a9c",
	"./search.svg": "31f0",
	"./settings.svg": "d20e",
	"./shutdown.svg": "464d",
	"./snow.svg": "e959",
	"./sort-ascending.svg": "1eb4",
	"./sort-descending.svg": "e8c7",
	"./sort-down.svg": "9b09",
	"./sort-unselected.svg": "67fb",
	"./sort-up.svg": "20f2",
	"./street-light.svg": "465a",
	"./string.svg": "4d19",
	"./style-presets.svg": "cf96",
	"./stylize.svg": "c17a",
	"./success.svg": "45d9",
	"./tasks.svg": "dc5c",
	"./thunderstorm.svg": "f6bb",
	"./time.svg": "47c0",
	"./tlt7.svg": "01f7",
	"./tomtom.svg": "cb22",
	"./traffic-lights.svg": "a81c",
	"./tram.svg": "c0ed",
	"./trash.svg": "07a7",
	"./trolleybus.svg": "e02c",
	"./type-node.svg": "7a15",
	"./undo.svg": "e532",
	"./user-avatar.svg": "1150",
	"./user.svg": "24b5",
	"./users.svg": "580f",
	"./visible-off.svg": "178e",
	"./visible-on.svg": "034e",
	"./wind.svg": "fcb6",
	"./work.svg": "68ad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5e10";